/**
 * UC-31: OnboardVendor
 * TOGAF Application ABB — TPRM vendor onboarding without UI deps.
 */
import type { Vendor } from '../../../types';
import type { IAppLogger } from '../../domain/ports/IAppLogger';
import type { IOrgManagement } from '../../domain/ports/IOrgManagement';

export interface OnboardVendorInput {
  vendorData: Partial<Vendor>;
}

export interface OnboardVendorOutput {
  ok: boolean;
  vendor?: Vendor;
  error?: string;
}

export interface OnboardVendorDependencies {
  orgManagement: IOrgManagement;
  logger?: IAppLogger;
}

export class OnboardVendorUseCase {
  constructor(private readonly deps: OnboardVendorDependencies) {}

  execute(input: OnboardVendorInput): OnboardVendorOutput {
    try {
      const vendor = this.deps.orgManagement.onboardVendor(input.vendorData);

      this.deps.logger?.log('debug', 'org.vendor_onboarded', {
        vendorId: vendor.id,
        name: vendor.name,
      });

      return { ok: true, vendor };
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      this.deps.logger?.log('warn', 'org.onboard_failed', { error: message });
      return { ok: false, error: message };
    }
  }
}